var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-4 m-4 text-center",staticStyle:{"border-radius":"2rem"}},[_vm._m(0),_c('div',[_c('Loader',{staticClass:"mb-4",attrs:{"loading":true}})],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4 pb-5",staticStyle:{"width":"100%"}},[_c('img',{staticStyle:{"filter":"invert(100%)"},attrs:{"src":require("@/assets/images/logo-light.png"),"alt":"","height":"200"}})])
}]

export { render, staticRenderFns }